import { selector, atom } from "recoil";
import { termConditions, policy } from "../services/apiCalls";

export const termConditionRefresh = atom({
  key: "termConditionRefresh",
  default: ""
})

export const editTermConditionVal = atom({
  key: "editTermConditionVal",
  default: {}
})

export const createTermConditionModal = atom({
  key: "createTermConditionModal",
  default: false
})

export const editTermConditionModal = atom({
  key: "editTermConditionModal",
  default: false
})

export const termConditionEditor = atom({
  key: "termConditionEditor",
  default: ""
})

export const termPolicy = selector({
  key: "termPolicy",
  get: async ({ get }) => {
    try {
      const res = get(termConditionRefresh);
      console.log(res)
      const result = await policy();
      return result.data || [];
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return [];
    }
  }
});

export const termCondition = selector({
  key: "termCondition",
  get: async ({ get }) => {
    try {
      const res = get(termConditionRefresh);
      console.log(res)
      const result = await termConditions();
      return result.data || [];
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return [];
    }
  }
});